const Reflux = require("reflux");
const FunnelHealthActions = require("../actions/funnel-health-actions");

const FunnelHealthStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      funnelHealth: [{
        user: {
          id: null,
          name: null
        },
        withTasks: {
          count: 0,
          percentage: 0
        },
        lateTasks: {
          count: 0,
          percentage: 0
        },
        noTasks: {
          count: 0,
          percentage: 0
        },
        total: 0
      }]
    }
  },

  init: function() {
    this.listenTo(FunnelHealthActions.fetchData, this.onFetchStarted);
    this.listenTo(FunnelHealthActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(FunnelHealthActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        funnelHealth: data.funnel_health.map(item => {
          return (
            {
              user: item.user,
              withTasks: item.with_tasks,
              lateTasks: item.late_tasks,
              noTasks: item.no_tasks,
              total: item.total
            }
          )
        })
      }
    }

    this.trigger(this.state);
  },

  onFetchFailed: function() {
    this.state = {
      loading: false,
      failed: true
    }

    this.trigger(this.state);
  }
});

module.exports = FunnelHealthStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/funnel-health-store.js